import React from 'react';

const CATEGORIES = [
	'new', 'welcome', 'coupons', 'sales', 'holidays', 'newsletter',
	'retail', 'industry', 'plain', 'announcement', 'events', 'marketing'
];

function CategorySelectionButtons({selectedCategories, setSelectedCategories, singleSelectionOnly}) {
	const handleToggle = (category) => {
		if (singleSelectionOnly) {
			setSelectedCategories(prev => (prev.includes(category) ? [] : [category]));
		} else {
			setSelectedCategories(prev =>
				prev.includes(category)
					? prev.filter(c => c !== category)
					: [...prev, category]
			);
		}
	};

	const baseChip = "rounded-full px-3 py-1 text-sm font-medium transition-colors duration-150 cursor-pointer select-none";
	const selected = "bg-emerald-100 text-emerald-800 border border-emerald-200 hover:bg-emerald-200/80";
	const unselected = "bg-white border border-slate-200 text-slate-700 hover:bg-slate-50";

	return (
		<div className="flex flex-wrap gap-2">
			{CATEGORIES.map((category) => {
				const isOn = selectedCategories.includes(category);
				return (
					<button
						key={category}
						type="button"
						aria-pressed={isOn}
						onClick={() => handleToggle(category)}
						className={`${baseChip} ${isOn ? selected : unselected}`}>
						{category}
					</button>
				);
			})}
		</div>
	);
}

export default CategorySelectionButtons;
